import initialState from './state.js';

export default {
    resetState(state) {
        Object.assign(state, initialState);
    },

    setEditingContact(state, contact) {
        state.editingContact = contact;
    },

    setSelectedContacts(state, contacts) {
        state.selectedContacts = contacts;
    },

    setContacts(state, contacts) {
        state.contacts = contacts;
    },

    addContact(state, contact) {
        state.contacts.push(contact);
    },

    updateContact(state, updatedContact) {
        if (!updatedContact.id) {
            return;
        }

        state.contacts.filter(contact => contact.id == updatedContact.id)
            .forEach(contact => Object.assign(contact, updatedContact));
    },

    removeContact(state, id) {
        state.contacts.splice(state.contacts.findIndex(c => c.id == id.id), 1);
    },

    updateContactPhone(state, updatedPhone) {
        if (!updatedPhone.id) {
            return;
        }

        state.contacts.filter(contact => contact.id == updatedPhone.contact_id)
            .forEach(contact => {
                contact.phones.filter(phone => phone.id == updatedPhone.id)
                    .forEach(phone => Object.assign(phone, updatedPhone));
            });
    },

    updatePagination(state, pagination) {
        state.pagination.from = pagination.from;
        state.pagination.to = pagination.to;
        state.pagination.total = pagination.total;
        state.pagination.lastPage = pagination.lastPage;
    },

    setPaginationPage(state, page) {
        state.pagination.currentPage = page;
    },
};
